import productsJSON from 'public/products.json';

export const useProductsStore = defineStore('products', () => {
  const DB = useDbStore();
  const productFetchPromise = ref<Promise<ItemI[]> | null>(null);
  const isFetched = ref(false);

  const localeList = useLocalStorage<ItemI[]>('productList', []);
  const list = ref<ItemI[]>([]);

  const fixedAppliances = computed(() => {
    const l = list.value.filter(item => item.type === 'fixed-appliances');
    if (l.length) return l;

    return localeList.value.filter(item => item.type === 'fixed-appliances');
  });

  const expanderDevices = computed(() => {
    const names = ['tooth-borne-rapid-palatal-expander', 'hybrid-hyrax', '4x-tad-telescopic-expander'];

    return fixedAppliances.value.filter(item => names.includes(item.name));
  });

  const signatureppliances = computed(() => {
    const l = list.value.filter(item => item.type === 'signature-appliances');
    if (l.length) return l;

    return localeList.value.filter(item => item.type === 'signature-appliances');
  });

  const surgicalGuides = computed(() => {
    const l = list.value.filter(item => item.type === 'surgical-guides');
    if (l.length) return l;

    return localeList.value.filter(item => item.type === 'surgical-guides');
  });

  const temporaryProsthetics = computed(() => {
    const l = list.value.filter(item => item.type === 'temporary-prosthetics');
    if (l.length) return l;

    return localeList.value.filter(item => item.type === 'temporary-prosthetics');
  });

  const functionalAppliances = computed(() => {
    const l = list.value.filter(item => item.type === 'functional-appliances');
    if (l.length) return l;

    return localeList.value.filter(item => item.type === 'functional-appliances');
  });

  const aligners = computed(() => {
    const l = list.value.filter(item => item.type === 'aligners');
    if (l.length) return l;

    const localeA = localeList.value.filter(item => item.type === 'aligners');
    if (localeA.length) return l;

    return productsJSON['alignersList'];
  });

  const alignerFacilitators = computed(() => {
    const l = list.value.filter(item => item.type === 'aligner-facilitators');
    if (l.length) return l;

    return localeList.value.filter(item => item.type === 'aligner-facilitators');
  });

  const digitalBiomechanicalAppliances = computed(() => {
    const l = list.value.filter(item => item.type === 'digital-biomechanical-appliances');
    if (l.length) return l;

    return localeList.value.filter(item => item.type === 'digital-biomechanical-appliances');
  });

  const diagnostics = computed(() => {
    const l = list.value.filter(item => item.type === 'diagnostics');
    if (l.length) return l;

    return localeList.value.filter(item => item.type === 'diagnostics');
  });

  const automatic = computed(() => {
    const l = list.value.filter(item => item.type === 'automatic');
    if (l.length) return l;

    return localeList.value.filter(item => item.type === 'automatic');
  });

  const distributeProducts = (products: ItemI[]) => {
    isFetched.value = true;

    localeList.value = products;
    list.value = products;

    isFetched.value = true;

    return products;
  };

  const initProducts = async () => {
    productFetchPromise.value = DB.getProducts();

    productFetchPromise.value.then(distributeProducts).catch((err) => {
      console.log('error', err);
    });

    return productFetchPromise.value;
  };

  const getProductByTypeAndName = (type: ItemTypeT, name: ItemNameT): ItemI => {
    return list.value.find(p => p.type === type && p.name === name)
      || localeList.value.find(p => p.type === type && p.name === name);
  };

  const convertServerOrderToOrder = (order: ServerOrderI): OrderI => {
    const additional = {};
    // console.log('ORDER', order);
    if (order?.expand?.user) {
      const phone = order?.expand?.user.phone || order?.expand?.user.deliveryDetails?.phone || order?.expand?.user.billingDetails?.phone || '';
      additional.contactInfo = { ...order?.expand?.user, phone };
      additional.points = order?.expand?.user?.cash;
      additional.userName = order?.expand?.user?.name;
    }

    if (order?.expand?.invoices) {
      additional.invoices = order?.expand?.invoices;
    }

    return {
      id: order.id,
      localId: order.localId,
      item: getProductByTypeAndName(order.itemType, order.itemName),
      stickers: order.customizer.stickers,
      lines: order.customizer.lines,
      pencils: order.customizer.pencils,
      file: order.file,
      files: order.files,
      approveFile: order.approveFile,
      approveFiles: order.approveFiles,
      approveFiles_meta: order.approveFiles_meta || {},
      approveComments: order.approveComments,
      comment: order.comment,
      patient: order.patient,
      created: order.created,
      status: order.status,
      approved: order.approved,
      totalPrice: order.totalPrice,
      userName: '',
      user: order.user,
      deliveryDetails: order.deliveryDetails,
      billingDetails: order.billingDetails,
      paid: order.paid,
      discount: order.discount,
      configuration: order.configuration,
      selectedInCart: order.selectedInCart,
      trackingNumber: order.trackingNumber,
      invoiceLink: order.invoiceLink,
      approvePrice: order.approvePrice,
      paymentMethod: order.paymentMethod,
      paidDate: order.paidDate,
      inboxDate: order.inboxDate,
      invoiceStatus: order.invoiceStatus,
      ...additional,
      // contactInfo: order.contactInfo,
    };
  };

  return {
    isFetched,
    productFetchPromise,

    list,

    fixedAppliances,
    expanderDevices,
    surgicalGuides,
    temporaryProsthetics,
    functionalAppliances,
    aligners,
    alignerFacilitators,
    digitalBiomechanicalAppliances,
    diagnostics,
    automatic,
    signatureppliances,

    initProducts,

    getProductByTypeAndName,
    convertServerOrderToOrder,
  };
});
